<template>
    <div id="app">
        <v-app id="qpc">
            <v-dialog
            v-model="dialog" persistent
            width="1080px"
            height="600px"
            >
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.process" label="프로세스"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.department" label="부서"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.classification" label="지표구분"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.factory" label="공장"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.line" label="라인"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.facility" label="공정"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.facility" label="설비"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.customerMasterName" label="고객사"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.equipmentMasterName" label="측정장비"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.management" label="관리항목"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.productMasterName" label="제품명"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.partMasterName" label="부품명"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.productMasterCode" label="품번"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.inspectionLOTNo" label="측정주기(LOTNO)"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" sm="6" md="4">
                                    <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="editedItem.inspectionDate"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                            v-model="editedItem.inspectionDate"
                                            label="검사일자"
                                            readonly
                                            v-on="on"
                                            />
                                        </template>
                                        <v-date-picker v-model="editedItem.inspectionDate" no-title scrollable>
                                            <v-spacer/>
                                            <v-btn small color="primary" @click="$refs.menu.save(editedItem.inspectionDate)">선택</v-btn>
                                            <v-btn small color="primary" @click="menu = false">취소</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="4" sm="6" md="4">
                                    <v-text-field v-model="editedItem.targetNumber" label="대상수"/>
                                </v-col>
                                <v-col cols="4" sm="6" md="4">
                                    <v-text-field v-model="editedItem.sampleNumber" label="샘플수"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedItem1" label="부적합항목1"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedNumber1" label="부적합수1"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedItem2" label="부적합항목2"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedNumber2" label="부적합수2"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedItem3" label="부적합항목3"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.defectedNumber3" label="부적합수3"/>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="saveItem">저장</v-btn>
                        <v-btn color="primary" @click="close">취소</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>

            <v-dialog
            v-model="dialogInfo" persistent
            width="1600px"
            scrollable
            >
                <v-card>
                    <v-card-title>
                        분석결과 - {{productMasterCode}}
                    </v-card-title>
                    <v-divider/>
                    <v-card-text
                        class="ma-0 pa-0"
                    >
                        <OutgoingInfo
                            :DataList="DataList"
                            :update="updateInfo"
                            :code="productMasterCode"
                            category="outgoing"
                        />
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" small @click="dialogInfo=false">닫기</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>
            <v-dialog
                v-model="dialogMonthlyTargetValue" persistent
                width="700px"
            >
                <v-card>
                    <v-card-title>
                        월별 목표값 - {{productMasterCode}}
                    </v-card-title>
                    <v-divider/>
                    <v-card-text
                    class="ma-0 pa-0"
                    >
                        <MonthlyTargetValue
                        :title="productMasterCode"
                        :code="productMasterCode"
                        category="outgoing"
                        :update="updateMonthlyTargetValue"
                        />
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" small @click="dialogMonthlyTargetValue=false">닫기</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>

            <v-card fluid flat>
                <v-card-title class="ma-0 pa-0">
                    <v-row class="ma-1 pa-0">
                        <span>출하검사</span>
                        <v-spacer/>
                        <v-col cols="3">
                            <v-select
                            v-model="productMasterCode"
                            :items="productMasterCodeItem"
                            label="품번"
                            />
                        </v-col>
                        <v-menu
                        ref="searchDateStart"
                        v-model="searchDate.menuStart"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="searchDate.start"
                        transition="scale-transition"
                        offset-y
                        min-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-col cols="1">
                                    <v-text-field
                                    v-model="searchDate.start"
                                    label="시작일"
                                    readonly
                                    v-on="on"
                                    />
                                </v-col>
                            </template>
                            <v-date-picker v-model="searchDate.start" no-title scrollable>
                                <v-spacer/>
                                <v-btn small color="primary" @click="$refs.searchDateStart.save(searchDate.start)">선택</v-btn>
                                <v-btn small color="primary" @click="searchDate.menuStart = false">취소</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-menu
                        ref="searchDateMenuEnd"
                        v-model="searchDate.menuEnd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="searchDate.end"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-col cols="1">
                                    <v-text-field
                                    v-model="searchDate.end"
                                    label="종료일"
                                    readonly
                                    v-on="on"
                                    />
                                </v-col>
                            </template>
                            <v-date-picker v-model="searchDate.end" no-title scrollable>
                                <v-spacer/>
                                <v-btn small color="primary" @click="$refs.searchDateMenuEnd.save(searchDate.end)">선택</v-btn>
                                <v-btn small color="primary" @click="searchDate.menuEnd = false">취소</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-col
                        cols="4"
                        class="ma-0 pa-0">
                            <v-row class="ma-0 pa-0">
                                <v-spacer/>
                                <v-btn color="primary" small @click="setDateDay" class="ma-0 mt-3 mr-1">
                                    <v-icon left small>mdi-calendar</v-icon>
                                    일
                                </v-btn>
                                <v-btn color="primary" small @click="setDateWeek" class="ma-0 mt-3 mr-1">
                                    <v-icon left small>mdi-calendar</v-icon>
                                    주
                                </v-btn>
                                <v-btn color="primary" small @click="setDateMonth" class="ma-0 mt-3 mr-1">
                                    <v-icon left small>mdi-calendar</v-icon>
                                    월
                                </v-btn>
                                <v-btn color="primary" small @click="setDateYear" class="ma-0 mt-3 mr-1">
                                    <v-icon left small>mdi-calendar</v-icon>
                                    년
                                </v-btn>
                                <v-btn color="primary" small @click="setDate5Year" class="ma-0 mt-3 mr-3">
                                    <v-icon left small>mdi-calendar</v-icon>
                                    5년
                                </v-btn>
                                <v-btn color="primary" small @click="search" class="ma-0 mt-3">
                                    <v-icon left small>mdi-magnify</v-icon>
                                    검색
                                </v-btn>
                            </v-row>
                            <v-row class="ma-0 pa-0">
                                <v-spacer/>
                                <v-btn color="primary" small @click="showInfo" class="ma-0 mt-3 mr-3">
                                    <v-icon left small>mdi-chart-line</v-icon>
                                    보기 (분석 결과)
                                </v-btn>
                                <v-btn color="primary" small class="ma-0 mt-3 mr-3" @click="appendItem">추가하기</v-btn>
                                <v-btn color="primary" small class="ma-0 mt-3" @click="ShowMonthlyTargetValue">월별목표값</v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-divider class="ma-0 pa-0"/>
                <v-card-text class="ma-0 pa-0">
                    <v-data-table
                    :headers="headers"
                    :items="DataList"
                    sort-by="inspectionDate"
                    :sort-desc="true"
                    class="ma-0 pa-1"
                    >
                        <template v-slot:item.productMasterName="{ item }">
                            <v-col class="ma-0 pa-0">
                                <span>{{item.productMasterName}}</span>
                            </v-col>
                            <v-col class="ma-0 pa-0">
                                <span>({{item.partMasterName}})</span>
                            </v-col>
                        </template>
                        <template v-slot:item.sampleNumber="{ item }">
                            <v-col class="ma-0 pa-0">
                                <span>{{item.sampleNumber}}</span>
                            </v-col>
                            <v-col class="ma-0 pa-0">
                                <span>({{item.targetNumber}})</span>
                            </v-col>
                        </template>
                        <template v-slot:item.defectedNumber1="{ item }">
                            <template v-if="item.defectedNumber1!=null">
                                <v-col class="ma-0 pa-0">
                                    <span>{{item.defectedNumber1}}</span>
                                </v-col>
                                <v-col class="ma-0 pa-0">
                                    <span>({{item.defectedItem1}})</span>
                                </v-col>
                            </template>
                        </template>
                        <template v-slot:item.defectedNumber2="{ item }">
                            <template v-if="item.defectedNumber2!=null">
                                <v-col class="ma-0 pa-0">
                                    <span>{{item.defectedNumber2}}</span>
                                </v-col>
                                <v-col class="ma-0 pa-0">
                                    <span>({{item.defectedItem2}})</span>
                                </v-col>
                            </template>
                        </template>
                        <template v-slot:item.defectedNumber3="{ item }">
                            <template v-if="item.defectedNumber3!=null">
                                <v-col class="ma-0 pa-0">
                                    <span>{{item.defectedNumber3}}</span>
                                </v-col>
                                <v-col class="ma-0 pa-0">
                                    <span>({{item.defectedItem3}})</span>
                                </v-col>
                            </template>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-col class="ma-0 pa-0">
                                <v-btn color="primary" class="ma-1" small @click="editItem(item)">
                                    <v-icon small class="mt-1">mdi-border-color</v-icon>
                                    수정
                                </v-btn>
                            </v-col>
                            <v-col class="ma-0 pa-0">
                                <v-btn color="primary" class="ma-1" small @click="deleteItem(item)">
                                    <v-icon small>mdi-eraser-variant</v-icon>
                                    삭제
                                </v-btn>
                            </v-col>
                        </template>

                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import OutgoingInfo from './OutgoingInfo'
import MonthlyTargetValue from '../MonthlyTargetValue'
import moment from 'moment'

export default {
  name: 'OutgoingInspection',
  components: {
    OutgoingInfo,
    MonthlyTargetValue
  },

  data: () => ({
    dialog: false,
    dialogInfo: false,
    dialogMonthlyTargetValue: false,
    menu: false,
    updateInfo: false,
    updateMonthlyTargetValue: false,
    searchDate: {
      menuStart: false,
      menuEnd: false,
      start: moment(new Date()).format('YYYY-MM-DD'),
      end: moment(new Date()).format('YYYY-MM-DD')
    },
    productMasterCode: '',
    productMasterCodeItem: [],
    headers: [
      {
        text: '프로세스',
        align: 'center',
        sortable: true,
        value: 'process'
      },
      { text: '부서',
        align: 'center',
        value: 'department'
      },
      { text: '지표구분',
        align: 'center',
        value: 'classification'
      },
      { text: '공장',
        align: 'center',
        value: 'factory'
      },
      { text: '라인',
        align: 'center',
        value: 'line'
      },
      { text: '공정',
        align: 'center',
        value: 'processName'
      },
      { text: '설비',
        align: 'center',
        value: 'facility'
      },
      { text: '고객사',
        align: 'center',
        value: 'customerMasterName'
      },
      { text: '측정장비',
        align: 'center',
        value: 'equipmentMasterName'
      },
      { text: '관리항목',
        align: 'center',
        value: 'management'
      },
      { text: '제품명(부품명)',
        align: 'center',
        value: 'productMasterName'
      },
      { text: '품번',
        align: 'center',
        value: 'productMasterCode'
      },
      { text: '측정주기(LOTNo)',
        align: 'center',
        value: 'inspectionLOTNo'
      },
      { text: '검사일자',
        align: 'center',
        value: 'inspectionDate'
      },
      { text: '샘플수(대상수)',
        align: 'center',
        value: 'sampleNumber'
      },
      { text: '부적합수',
        align: 'center',
        value: 'defectedNumber'
      },
      { text: '부적합율(ppm)',
        align: 'center',
        value: 'defectedRate'
      },
      { text: '부적합수1',
        align: 'center',
        value: 'defectedNumber1'
      },
      { text: '부적합수2',
        align: 'center',
        value: 'defectedNumber2'
      },
      { text: '부적합수3',
        align: 'center',
        value: 'defectedNumber3'
      },
      { text: '수정',
        value: 'action',
        sortable: false
      }
    ],
    DataList: [],
    editedIndex: -1,
    editedItem: {
      _id: '',
      process: '',
      department: '',
      classification: '',
      factory: '',
      line: '',
      processName: '',
      facility: '',
      customerMasterName: '',
      equipmentMasterName: '',
      management: '',
      productMasterName: '',
      partMasterName: '',
      productMasterCode: '',
      inspectionLOTNo: '',
      inspectionDate: '',
      targetNumber: '',
      sampleNumber: '',
      defectedNumber: '',
      defectedRate: '',
      defectedItem1: '',
      defectedNumber1: '',
      defectedItem2: '',
      defectedNumber2: '',
      defectedItem3: '',
      defectedNumber3: ''
    },
    defaultItem: {
      _id: '',
      process: '',
      department: '',
      classification: '',
      factory: '',
      line: '',
      processName: '',
      facility: '',
      customerMasterName: '',
      equipmentMasterName: '',
      management: '',
      productMasterName: '',
      partMasterName: '',
      productMasterCode: '',
      inspectionLOTNo: '',
      inspectionDate: '',
      targetNumber: '',
      sampleNumber: '',
      defectedNumber: '',
      defectedRate: '',
      defectedItem1: '',
      defectedNumber1: '',
      defectedItem2: '',
      defectedNumber2: '',
      defectedItem3: '',
      defectedNumber3: ''
    }
  }),

  created () {
    this.getProductMasterCode()
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '추가하기' : '수정하기'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {

    getProductMasterCode () {
      this.productMasterCodeItem = []
      this.$axios.get('/api/outgoinginspections', this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get outgoinginspections -> ' + res)
          for (let i = 0; i < res.data.length; i++) {
            this.productMasterCodeItem.push(res.data[i].productMasterCode)
          }
        })
        .catch((e) => {
          console.log('failed get outgoinginspections -> ' + JSON.stringify(e.response.data))
        })
    },

    // getItemList () {
    search () {
      // DB 리스트 가져오기.
      this.DataList = []
      let query = this.productMasterCode + '?startDate=' + this.searchDate.start + '&endDate=' + this.searchDate.end
      this.$axios.get('/api/outgoinginspections/' + query, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get outgoinginspections -> ' + res)
          for (let i = 0; i < res.data.length; i++) {
            this.DataList.push(res.data[i])
          }
        })
        .catch((e) => {
          console.log('failed get outgoinginspections -> ' + JSON.stringify(e.response.data))
        })
    },

    saveItem () {
      if (this.editedItem.inspectionDate.length === 0) {
        this.$dialog.alert('검사일자를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedItem.targetNumber.length === 0) {
        this.$dialog.alert('대상수를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedItem.sampleNumber.length === 0) {
        this.$dialog.alert('샘플수를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }
      if (this.editedItem.defectedItem1.length === 0) {
        this.$dialog.alert('부작합항목을 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }

      if (this.editedItem.defectedNumber1.length === 0) {
        this.$dialog.alert('부적합수를 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }

      var defectedNumberSum = this.editedItem.defectedNumber1 * 1 + this.editedItem.defectedNumber2 * 1 + this.editedItem.defectedNumber3 * 1
      var defectedRateTemp = parseInt(1000000 * defectedNumberSum / parseInt(this.editedItem.targetNumber))

      if (this.editedIndex > -1) {
        // 출하검사 수정.
        this.$axios.put('/api/outgoinginspections', this.editedItem, this.$Common.headerApiRequest())
          .then((res) => {
            console.log('succeeded put outgoinginspections -> ' + res)
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.close()
            this.$dialog.alert('출하검사가 수정 되었습니다.', { okText: '확인' }).then(function () {
            })
            this.getItemList()
          })
          .catch((e) => {
            console.log('failed put outgoinginspections -> ' + JSON.stringify(e.response.data))
          })
      } else {
        // 출하검사 추가.
        this.$axios.post('/api/outgoinginspections', this.editedItem, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded post outgoinginspections -> ' + res)
          this.DataList.push(this.editedItem)
          this.close()
          this.$dialog.alert('수입검사가 추가 되었습니다.', { okText: '확인' }).then(function () {
          })
          this.getItemList()
        })
        .catch((e) => {
          console.log('failed post outgoinginspections -> ' + JSON.stringify(e.response.data))
        })
      }
    },

    deleteItem: function (item) {
      // 출하검사 삭제.
      const self = this
      this.$dialog
        .confirm('이 정보를 삭제하시겠습니까?', { okText: '확인', cancelText: '취소' })
        .then(function () {
          self.$axios.delete('/api/outgoinginspections/' + item.id, self.$Common.headerApiRequest())
          .then(() => {
            console.log('succeeded delete outgoinginspections')
            self.$dialog.alert('출하검사가 삭제 되었습니다.', { okText: '확인' }).then(function () {
              const index = self.DataList.indexOf(item)
              self.DataList.splice(index, 1)
            })
          })
          .catch((e) => {
            console.log('failed delete outgoinginspections -> ' + JSON.stringify(e.response.data))
          })
        })
        .catch(function () {
        })
    },

    appendItem () {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = true
    },

    editItem: function (item) {
      this.editedIndex = this.DataList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    setDateDay () {
      this.searchDate.start = moment(new Date()).format('YYYY-MM-DD')
      this.searchDate.end = moment(new Date()).format('YYYY-MM-DD')
      this.search()
    },

    setDateWeek () {
      this.searchDate.start = moment(new Date()).add(-1, 'weeks').format('YYYY-MM-DD')
      this.searchDate.end = moment(new Date()).format('YYYY-MM-DD')
      this.search()
    },

    setDateMonth () {
      this.searchDate.start = moment(new Date()).add(-1, 'months').format('YYYY-MM-DD')
      this.searchDate.end = moment(new Date()).format('YYYY-MM-DD')
      this.search()
    },

    setDateYear () {
      this.searchDate.start = moment(new Date()).add(-1, 'years').format('YYYY-MM-DD')
      this.searchDate.end = moment(new Date()).format('YYYY-MM-DD')
      this.search()
    },

    setDate5Year () {
      this.searchDate.start = moment(new Date()).add(-5, 'years').format('YYYY-MM-DD')
      this.searchDate.end = moment(new Date()).format('YYYY-MM-DD')
      this.search()
    },

    showInfo () {
      if (this.DataList.length === 0) {
        this.$dialog.alert('검색된 데이터가 없습니다.', { okText: '확인' }).then(function () {
        })
        return
      }
      this.dialogInfo = true
      this.updateInfo = !this.updateInfo
    },

    ShowMonthlyTargetValue () {
      this.dialogMonthlyTargetValue = true
      this.updateMonthlyTargetValue = !this.updateMonthlyTargetValue
    }

  }
}
</script>

<style scoped/>
